import API from '../.';
const ENTITY = 'user';

const updateUserProfile = (data, id) =>
    API.patch(`/api/v1/${ENTITY}/${id}/`, data);

export default updateUserProfile;
